<template>
  <div class="form-module">
    <p class="module-title">{{ $locale("rules.nationwideTicketSetting") }}</p>
    <div class="key-block">
      <div class="block-r">
        <div class="clearfix">
          <el-form-item :label="$locale('rules.availabilityMovieTickets') + ' *'" class="w387">
            <el-select v-model="form.commonCoupon">
              <el-option :value="true" :label="$locale('rules.available')"></el-option>
              <el-option :value="false" :label="$locale('rules.unusable')"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$locale('rules.availabilityOtherNationalTickets') + ' *'" class="w387">
            <el-select v-model="form.otherCommonCoupon">
              <el-option :value="true" :label="$locale('rules.available')"></el-option>
              <el-option :value="false" :label="$locale('rules.unusable')"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ruleTemplateCommonCouponModule",
  data() {
    return {
      // the "form" data will be effecting by "formObj", you have to edit file: "src/assets/js/ruleTemplate.js", func: "createFormObj"
      form: {
        commonCoupon: false,
        otherCommonCoupon: true,
      },
    };
  },
  props: {
    formObj: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    formObj() {
      this.form = { commonCoupon: this.formObj.ticketRule.commonCoupon, otherCommonCoupon: this.formObj.ticketRule.otherCommonCoupon, };
    },
  },
};
</script>
